export type OrientationMode = 'map' | 'fixed' | 'readable' | 'screen';

/** Ce que le réglage écrit sur un texte ou une image (`rotation`, `rotateWithMap`, `keepReadable`). */
export type OrientationValues = { rotation?: number; rotateWithMap?: boolean; keepReadable?: boolean; };

export const orientationModeOf = (values: OrientationValues | undefined): OrientationMode => {
	if (values?.rotateWithMap) return 'screen';
	if (values?.keepReadable) return 'readable';

	return values?.rotation === undefined ? 'map' : 'fixed';
};
